/**
 *
 * Asynchronously loads the component for RenderLogs
 *
 */

import { lazyLoad } from 'utils/loadable';

export const RenderLogs = lazyLoad(
    () => import('./index'),
    module => module.default,
);
